import { CircuitResponse } from './circuit-response';
import { DrivePackageResponse } from './drive-package-response';
import { CoilResponse } from './coil-response';
import { OperatingPoint } from './operating-point';
import { FanCurvePerformanceEntry } from './ratings/fan-curve-performance-entry';
import { FanCurve } from './ratings/fan-curve';

export class UnitRatingResponse {
  Airflow!: number;
  StandardAirflow!: number;
  CircuitResponse!: CircuitResponse;
  AlternateCircuit!: CircuitResponse;
  PrimaryDrivePackage!: DrivePackageResponse;
  SecondaryDrivePackage!: DrivePackageResponse;
  PrimaryCoilResponse!: CoilResponse;
  SecondaryCoilResponse!: CoilResponse;
  ElectricHeatResponse!: CoilResponse;
  LowSpeed!: OperatingPoint;
  MediumSpeed!: OperatingPoint;
  HighSpeed!: OperatingPoint;
  PerformanceSummary: FanCurvePerformanceEntry[] = [];
  FanCurveData: FanCurve[] = [];
  MaxAirflowValue = 0;
  MaxTspValue = 0;
  ErrorMessage!: string;
  primaryCooling!: boolean;
}
